import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";

import PropTypes from "prop-types";
import { Alert, FormControl, FormGroup, FormLabel } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import DatePickerComponent from "../../common/datePicker/DatePicker";

class ManageSurveyTempUserCreateAndEdit extends Component {
    onChangeProperty(e) {
        const {changeTempUserProperty} = this.props;
        changeTempUserProperty(e.target.name, e.target.value);
    }

    onChangeDate(e) {
        const {changeTempUserProperty} = this.props;
        changeTempUserProperty("dateOfValidity", e);
    }

    render() {
        const {
            dateOfValidity,
            editTempUserDialog,
            firstname,
            lastname,
            username,
            usernameAlreadyExists,
            currentUsernameIsValid
        } = this.props;
        return (
            <Modal.Body className="edit-temp-user-dialog">
                <FormGroup  className="mb-3">
                    <FormLabel>
                        <FormattedMessage id="manage.survey.user.name"/>{" "}
                    </FormLabel>
                    <FormControl name="firstname" defaultValue={firstname} onChange={(e) => this.onChangeProperty(e)}/>
                </FormGroup>
                <FormGroup  className="mb-3">
                    <FormLabel>
                        <FormattedMessage id="manage.survey.user.lastname"/>
                    </FormLabel>
                    <FormControl name="lastname" defaultValue={lastname} onChange={(e) => this.onChangeProperty(e)}/>
                </FormGroup>
                <FormGroup  className="mb-3">
                    <FormLabel>
                        <FormattedMessage id="manage.survey.user.email"/>
                    </FormLabel>
                    <FormControl
                        isValid={username && currentUsernameIsValid && !usernameAlreadyExists}
                        name="username"
                        defaultValue={username}
                        onChange={(e) => this.onChangeProperty(e)}
                        disabled={editTempUserDialog}
                    />
                </FormGroup>
                {username && usernameAlreadyExists && (
                    <Alert variant="warning">
                        <FormattedMessage id="user.management.create.new.user.exists.warning"/>
                    </Alert>
                )}
                {!currentUsernameIsValid && (
                    <Alert variant="warning">
                        <FormattedMessage id="user.management.create.new.user.username.warning"/>
                    </Alert>
                )}
                <FormGroup  className="mb-3">
                    <FormLabel>
                        <FormattedMessage id="manage.survey.user.inactive.validity"/>
                    </FormLabel>
                    <DatePickerComponent
                        dateFormat={"Day"}
                        name="dateOfValidity"
                        value={
                            dateOfValidity
                                ? typeof dateOfValidity === "string"
                                    ? dateOfValidity
                                    : dateOfValidity.toISOString()
                                : null
                        }
                        onChange={(value) => {
                            if (typeof value !== "string") {
                                this.onChangeDate(value.toISOString());
                            }
                        }}
                    />
                </FormGroup>
            </Modal.Body>
        );
    }
}

ManageSurveyTempUserCreateAndEdit.propTypes = {
    editTempUserDialog: PropTypes.bool,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    username: PropTypes.string,
    usernameAlreadyExists: PropTypes.bool,
    dateOfValidity: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    changeTempUserProperty: PropTypes.func
};
export default injectIntl(ManageSurveyTempUserCreateAndEdit);
